export default {
  delivery: "Delivery/ {{date}}",
  pickup: "Pickup/ {{date}}",
  room_service: 'Room service/ {{date}}',
  table_service: 'Table service/ {{date}}',
  now: "ASAP",
  unavailable: "Unavailable",
  today: 'today',
  buttons: {
    edit: 'Edit →',
  },
};
